module.exports = __webpack_public_path__ + "assets/images/profiles/2020-1.jpg?v=3221c3af";